import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';

export default function CardModal({ modalVisbitlity, toggleModalVisibility, title, content }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    useEffect(() => {
        showModal(modalVisbitlity)
    }, [modalVisbitlity])

    const showModal = (visibility) => {
        setIsModalVisible(visibility);
    };

    const handleOk = () => {
        setIsModalVisible(false);
        toggleModalVisibility(false)
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        toggleModalVisibility(false)
    };

    return (
        <>
            <Modal style={{ padding: "10px", background: "#DC143C" }}
                visible={isModalVisible} onOk={handleOk}
                closable={false}
                cancelButtonProps={{
                    style: {
                        display: "none",
                    },
                }}>
                <div>
                    <h1 style={{ fontSize: "200%" }}>
                        {title}
                    </h1>
                    <h3>
                        {content}
                    </h3>

                </div>
            </Modal>
        </>
    );
};

// ReactDOM.render(<App />, mountNode);